// extracted by mini-css-extract-plugin
export default {"chart":"styles_chart__bQrB2","react-flow__nodes":"styles_react-flow__nodes__VbYdG","react-flow__node":"styles_react-flow__node__oqr8e"};